import toast from 'react-hot-toast'

// eslint-disable-next-line import/prefer-default-export
export function errorsForm(err, t) {
  let errString = t('login:errors.unknown')

  if (err && err.code === 409) {
    errString = t('common:userAlreadyExists')
  }
  if (err && err.message.includes('Login failure')) {
    errString = t('login:errors.loginFailure')
  }
  if (err && err.message === 'Invalid login') {
    errString = t('login:errors.invalidLogin')
  }
  if (err && err.message.includes('Too many failed attempts')) {
    errString = t('login:errors.tooManyAttempts')
  }
  if (err && err.message.includes("Le compte n'a pas été vérifié")) {
    errString = t('login:errors.notVerified')
  }
  toast.error(errString, {
    className: 'toast-login-error',
  })
}
